<template>
  <div>
    <Bar text="企业信息"></Bar>
    <div class="e-flex jc-center mt-6">
      <el-form
        label-position="right"
        ref="form"
        :model="form"
        :rules="rules"
        style="width: 600px"
        label-width="80px"
      >
        <el-form-item label="企业名称" prop="bidderCompanyName">
          <el-input
            v-model="form.bidderCompanyName"
            name="bidderCompanyName"
            placeholder="请填写企业名称"
            :disabled="isHlj"
          />
        </el-form-item>
            <el-form-item
      v-if="form.sourceRadio === '0'"
      label="统一社会信用代码"
      prop="bidderSocialCreditCode"
    >
      <el-input
        v-model="form.bidderSocialCreditCode"
        placeholder="请填写统一社会信用代码"
      />
      <el-button type="text">
        <span @click="to('https://www.cods.org.cn/')">点此查询统一社会信用代码</span>
      </el-button>
    </el-form-item>

        <el-form-item label="企业地址" prop="orgAddress">
          <el-input v-model="form.orgAddress" placeholder="请填企业地址" />
        </el-form-item>
        <el-form-item label="企业电话" prop="orgTel">
          <el-input
            v-model="form.orgTel"
            name="orgTel"
            placeholder="请填企业电话"
          />
        </el-form-item>

        <el-form-item label="企业法人" prop="orgLegalPerson">
          <el-input
            v-model="form.orgLegalPerson"
            name="orgLegalPerson"
            placeholder="请填写企业法人"
          />
        </el-form-item>
        <el-form-item label="联系人" prop="bidderLinkName">
          <el-input
            v-model="form.bidderLinkName"
            name="bidderLinkName"
            placeholder="请填写联系人"
          />
        </el-form-item>
        <el-form-item label="联系方式" prop="bidderMobilePhone">
          <el-input
            v-model="form.bidderMobilePhone"
            placeholder="请填写联系人手机号（保函申请人手机号）"
            name="bidderMobilePhone"
          />
        </el-form-item>
        <el-form-item
          label="营业执照"
          prop="businessLicense"
          class="form-item-full"
        >
          <UP
            uploadTitle="上传营业执照"
            @fileIdCb="uploadSuccess"
            :fileId="form.businessLicense"
            accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
          >
            <template #explain>
              <ul slot="tip" class="el-upload__tip">
                <li>支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档</li>
              </ul>
            </template></UP
          >
        </el-form-item>
        <el-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
          <el-button type="primary" @click="submitForm" class="elBtn">
            下一步
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import bar from '../projectBar/bar'
import uploadE from '../../../common/upload/uoload.vue'
import { to } from '@/shared/location'
import { bidderMobilePhonePass } from '@/shared/validate'
import { mapMutations, mapState, LETTER } from '@/store/modules/letter'
import { mapGetters, CONFIG_GETTERS } from '@/store/modules/config'
import { cloneDeep } from 'lodash'
import { getUserRes } from '@/api/user'
import { ORDER_TYPE, saveCurrentDraft } from '@/shared/guaranteeDraft'
export default {
  data() {
    let businessLicensePass = (rule, value, callback) => {
      if (this.form.businessLicense) {
        callback()
      } else {
        callback(new Error('请上传营业执照'))
      }
    }

    return {
      form: {},
      draftSaving: false,
      rules: {
        businessLicense: [
          {
            required: true,
            validator: businessLicensePass,
          },
        ],
        orgLegalPerson: [
          { required: true, message: '请填写企业法人', trigger: 'change' },
        ],
        bidderCompanyName: [
          { required: true, message: '请填写企业名称', trigger: 'change' },
        ],
        bidderMobilePhone: [
          {
            required: true,
            trigger: 'blur',
            validator: bidderMobilePhonePass,
          },
        ],
        orgTel: [
          { required: true, message: '请填写企业电话', trigger: 'change' },
        ],
        orgAddress: [
          { required: true, message: '请填写企业地址', trigger: 'change' },
        ],
        bidderLinkName: [
          { required: true, message: '请填写联系人', trigger: 'change' },
        ],
        bidderSocialCreditCode: {
          required: true,
          message: '请填写统一社会信用代码',
        },
      },
    }
  },
  computed: {
    ...mapState({
      formStorage: 'guarantee',
    }),
    ...mapGetters({
      isZCMOrigin: CONFIG_GETTERS.IS_ZCM_ORIGIN,
    }),
    isCqsw() {
      return this.$store.state.letter.isCqsw
    },
    isHlj() {
      return this.$store.state.letter.isHlj
    },
  },
  components: {
    Bar: bar,
    UP: uploadE,
  },
  beforeMount() {
    // step 切换恢复：从 Vuex letter.guarantee 读（父组件 init(data) 在 nextTick 后覆盖为最新值）
    const { formStorage } = this
    this.form = cloneDeep(formStorage || {})
    const { reapply } = this.$route.query
    this.form.reapply = reapply
    if (this.isCqsw && !this.form.apiId) {
      this.form.apiId = 'cqsw_v6'
    }
  },
  mounted() {
    // 自动填充弹窗已迁移到 tryAutoFill()，由父组件在缓存检查之后主动调
  },
  methods: {
    ...mapMutations({
      guarantee: LETTER.GUARANTEE,
    }),
    to: to,
    init(data) {
      this.form = cloneDeep(data || {})
      if (this.isCqsw && !this.form.apiId) {
        this.form.apiId = 'cqsw_v6'
      }
    },
    uploadSuccess(res) {
      this.form.businessLicense = res.url
      this.$refs.form.validateField('businessLicense')
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.guarantee(this.form)
          this.$emit('changeIndex', 1)
        }
      })
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        await saveCurrentDraft(this, ORDER_TYPE.ELECTRONIC_9600, 0, this.form)
      } finally {
        this.draftSaving = false
      }
    },
    getUserInfo() {
      getUserRes().then((v) => {
        if (typeof v.data === 'object') {
          this.$set(this.form, 'bidderCompanyName', v.data.companyName)
          this.$set(this.form, 'bidderSocialCreditCode', v.data.unifySocietyCreditCode)
          this.$set(this.form, 'orgAddress', v.data.registeredAddress)
          this.$set(this.form, 'orgLegalPerson', v.data.legalPerson)
          this.$set(this.form, 'bidderLinkName', v.data.linkMan)
          this.$set(this.form, 'bidderMobilePhone', v.data.linkManPhone)
          this.$set(this.form, 'businessLicense', v.data.businessLicense)
        }
      })
    },
    /**
     * 由父组件在"无缓存 / 用户选重新申请"之后主动调用，
     * 保证弹窗顺序：缓存弹窗 →（没有或跳过）→ 自动填充弹窗
     */
    tryAutoFill() {
      if (!this.$route.query.outerOrderNo &&
          !this.$route.query.orderID &&
          !this.isZCMOrigin) {
        this.$confirm('是否自动填入资料库中企业信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.getUserInfo()
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.el-upload__tip {
  list-style-type: decimal;
  padding-left: 14px;
}
</style>
